import React from "react";
import "../styles/Footer.css"; // Import the CSS file
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import locationImg from "../assets/location.jpeg";
import {
  faInstagram,
  faFacebookF,
  faYoutube,
  faPinterestP,
} from "@fortawesome/free-brands-svg-icons";
import {
  faHome,
  faGem,
  faBlog,
  faInfoCircle,
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
  const googleMapsLink = "https://www.google.com/maps/place/SQUAREFEET+MARBLE/@26.6128219,74.8477808,17z/data=!3m1!4b1!4m6!3m5!1s0x396bf1d97cdb76e5:0x21d10e31c010ddf!8m2!3d26.6128171!4d74.8503557!16s%2Fg%2F11ffmnnk00?entry=ttu&g_ep=EgoyMDI1MTAxMy4wIKXMDSoASAFQAw%3D%3D";
const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        {/* About Section */}
        <div className="footer-section">
          <h3>Square Feet Marble</h3>
          <p>
            Leading supplier of imported marble since 1969. We bring the
            world&apos;s finest marble collections to your doorstep.
          </p>
          <div className="social-links">
            <a href="https://www.instagram.com/squarefeetmarble/" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.facebook.com/SquarefeetMarble/" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="https://www.youtube.com/@squarefeetmarble" aria-label="YouTube">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a href="https://in.pinterest.com/marblesquarefeet/" aria-label="Pinterest">
              <FontAwesomeIcon icon={faPinterestP} />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3>Quick Links</h3>
          <div className="quick-links">
            <a href="/">
              <FontAwesomeIcon icon={faHome} /> Home
            </a>
            <a href="/imported-marble">
              <FontAwesomeIcon icon={faGem} /> Products
            </a>
            <a href="/blog">
              <FontAwesomeIcon icon={faBlog} /> Blogs
            </a>
            <a href="/about">
              <FontAwesomeIcon icon={faInfoCircle} /> About Us
            </a>
            <a href="/contact">
              <FontAwesomeIcon icon={faEnvelope} /> Contact
            </a>
          </div>
        </div>

        {/* Contact Info */}
        <div className="footer-section">
          <h3>Contact Us</h3>
          <div className="contact-item">
            <FontAwesomeIcon icon={faMapMarkerAlt}style={{ marginTop: "1rem" }} />
            <div>
              <p>SQUAREFEET MARBLE,</p>
              <p>Makrana Road, </p>
              <p>Madanganj-Kishangarh, dist- Ajmer</p>
              <p>Rajasthan 305801, India</p>
            </div>
          </div>
          <div className="contact-item">
            <FontAwesomeIcon icon={faPhone} style={{ marginTop: "1rem" }}/>
            <p>+91 9950999997 , +91 9829078451 </p>
          </div>
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope}style={{ marginTop: "1rem" }} />
            <p >squarefeetmarble@gmail.com</p>
          </div>
        </div>

        {/* Location Map */}
        <div className="footer-section">
          <h3>Visit Our Showroom</h3>
             <div
      className="footer-map"
      onClick={() => window.open(googleMapsLink, "_blank")}
      style={{ cursor: "pointer" }}
    >
  <img src={locationImg} alt="Map Icon" />
    </div>
          <p style={{ marginTop: "0.5rem", fontSize: "0.85rem" }}>
            Open : 8AM - 10PM
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Square Feet Marble by Bhandari&apos;s. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
